import { Component, Prop, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import { CPRS_TRAINING_APPLICATION_QUERY } from "@/graphql/cprs-training-application-query";
import {
  CertificationPartOneForm,
  FormFieldContents,
  FormNavbar,
} from "@/models/certification-part-one-form/certification-part-one-form.interface";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import { trainingFormApi } from "@/providers/apis/certification-part-one-form";
import DateTimePickerComponent from "../date-time-picker/date-time-picker.component.vue";
import CertificationPartOnePreviewFormComponent from "../certification-part-one-preview-form/certification-part-one-preview-form.component.vue";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { utils } from "@/utils/utils";
import MultiRadioButton from "../multi-radio-button/multi-radio-button.component.vue";
import moment from "moment";
import { loginApi } from "@/providers/apis/login";
import DropdownListComponent from "../dropdown-list/dropdown-list.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import EligibilityPopupComponent from "../eligibility-qsn-valid-popup/eligibility-qsn-valid-popup.vue";
import { User } from "@/models/common-interface/common.interface";

@Component({
  name: "certification-part-one-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-multi-radio": MultiRadioButton,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-date-time-picker": DateTimePickerComponent,
    "b-preview-form": CertificationPartOnePreviewFormComponent,
    "b-form-dropdown": DropdownListComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
    EligibilityPopupComponent,
  },
})
export default class CertificationPartOneFormComponent extends Vue {
  public formPagination = 0;
  public formName = "certificationPartOneBasicDetails";
  public applicationData: Array<CertificationPartOneForm> = [];
  public applicationNavData: FormNavbar[] = [];
  public formData: FormFieldContents[] = [];
  public isNavLoad = false;
  public isScroll = false;
  public isValid = false;
  public applicationCode: any;
  public formApplicationId = "";
  public getCprsBasicData: any;
  public currentForm: any;
  public fileData: File[] = [];
  public fileLink: any;
  public signatureInvalid = false;
  public saveDataDraft = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public payLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    certificationPartOneBasicDetails: {
      firstName: "",
      lastName: "",
      otherFirstName: "",
      otherLastName: "",
      preferredName: "",
      gender: "",
      socialSecurityNumber: "",
      dob: "",
      servedAsMilitay: [],
      ethnicHeritage: [],
      ethnicHeritageNotListed: "",
      trainingcity: [],
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      phone: "",
      email: "",
      workEmail: null,
    },
    certificationPartOneEducationExperience: {
      currentlyEmployed: [],
      highSchool: [],
      highSchoolNotListed: "",
      licences: [],
      licencesNotListed: "",
      certificateFiles: [],
      firstJobDetails: "",
      secondJobDetails: "",
    },
    certificationPartOneProgrammaticEligibilityQuestions: {
      recoveryFromMentalDisorder: "",
      isRecoveryFromMentalDisorder: "",
      recoveryFromSubstanceDisorder: "",
      recoveryFromSubstanceDisorderLastYear: "",
      willingToDisclose: [],
      participateDiscussions: [],
      conservator: [],
    },
    certificationPartOneRecoveryNarrative: {
      descripePersonalRecovery: "",
      regularBasisToRecover: "",
      strengthsToRecovery: "",
      planToDeal: "",
      ledAGroup: "",
      likeAboutLed: "",
      groupLeadFeel: "",
      taughtAClass: "",
      likeAboutTaught: "",
      feelAboutTeaching: "",
      bestExperience: "",
      supportSystemDescription: "",
      BecomeACertifiedPeer: "",
      goodCandidateTowork: "",
      likeUsToKnow: "",
    },
    certificationPartOneSignature: {
      isSignature: "",
      submissionDate: "",
    },
  };
  public formTitle = {
    main_title: "",
    sub_title: "",
  };
  public isLoading = true;
  public errorMessage = "";
  public hideDiv: string[] = [
    "likeAboutLed",
    "groupLeadFeel",
    "likeAboutTaught",
    "feelAboutTeaching",
    "recoveryFromSubstanceDisorderLastYear",
    "isRecoveryFromMentalDisorder",
    "ethnicHeritageNotListed",
    "highSchoolNotListed",
    "licencesNotListed",
  ];
  public checkField: string[] = [
    "recoveryFromMentalDisorder",
    "recoveryFromSubstanceDisorder",
    "ledAGroup",
    "taughtAClass",
    "ethnicHeritage",
    "highSchool",
    "licences",
  ];
  public textAreaCount = 0;
  public isEdit = false;
  public avoidSpecialCharandNumber = false;
  public checkValidForm = false;
  public formCompletedIndex: number[] = [];
  public mainId = "app";
  public currentRoute = "";
  public isFileValid = false;
  public isErrDobAge = false;
  public notFilesUploadedKeyNames: string[] = [];
  public eligibilityPopup = false;
  public userDetails: User = {} as User;
  public eligibilityPopupMsg = "";
  constructor() {
    super();
  }

  public async created() {
    this.userDetails = utils.getUserDetails();
    this.currentRoute = this.$route.path;
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
    loginApi
      .logInWithCredential(
        appConfigService.getClientId(),
        appConfigService.getClientKey(),
        "anonymous"
      )
      .then((data) => {
        this.isLoading = false;
        localStorage.setItem("anonymousToken", data.access_token);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
    this.isLoading = true;
    let payloadStorage: any = localStorage.getItem("partOneCertificatePayload");
    // Restore which steps were completed (validated via Next) so teal + the
    // Preview gate survive reloads. Only Next writes this, so it is accurate; we
    // do NOT auto-mark the current page here.
    const formFilledIndex: any = localStorage.getItem("partOneFormFilledIndex");
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((d: string) => {
        const n = Number(d);
        if (!isNaN(n) && !this.formCompletedIndex.includes(n)) {
          this.formCompletedIndex.push(n);
        }
      });
    }

    // A saved draft is restored; nothing else is pre-populated. A logged-in
    // applicant's Basic Details used to be filled in from their existing record
    // (getCertificateDetials), which put an applicant's name, address and email
    // into a blank application they had not typed - stale the moment any of it
    // had changed, and easy to submit without noticing.
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.payLoadData = { ...this.payLoadData, ...payloadStorage };
    }

    this.$watch(
      () => this.payLoadData.certificationPartOneBasicDetails.dob,
      (newVal: string) => {
        if (newVal) {
          const dobDate = new Date(newVal);
          const minAgeDate = new Date();
          minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
          this.isErrDobAge = dobDate > minAgeDate;
        } else {
          this.isErrDobAge = false;
        }
      },
      { immediate: true }
    );
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CPRS_TRAINING_APPLICATION_QUERY}`,
      })
      .then((result) => {
        this.isLoading = false;
        this.applicationData = result.data.cprsTrainingApplicationForms.data;
        this.formTitle = {
          main_title: this.applicationData[0].attributes.main_title,
          sub_title: this.applicationData[0].attributes.sub_title,
        };
        this.applicationNavData =
          this.applicationData[0].attributes.training_application_navbar;
        this.formData = this.applicationData[0].attributes.form_fields;
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index], true);
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
          this.syncStepZeroOnLoad();
        });
      });
  }
  public mounted() {
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
  }
  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "certificationPartOneBasicDetails") {
      this.formPagination = 0;
    } else if (slug == "certificationPartOneEducationExperience") {
      this.formPagination = 1;
    } else if (slug == "certificationPartOneProgrammaticEligibilityQuestions") {
      this.formPagination = 2;
    } else if (slug == "certificationPartOneRecoveryNarrative") {
      this.formPagination = 3;
    } else if (slug == "certificationPartOneSignature") {
      this.payLoadData.certificationPartOneSignature.isSignature = "";
      localStorage.setItem(
        "partOneCertificatePayload",
        JSON.stringify(this.payLoadData)
      );
      this.formPagination = 4;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  /**
   * The 18-and-over check Next runs before it will save Basic Details, pulled
   * out so the tab-click path enforces exactly the same rule: a draft must not
   * be creatable by clicking a tab when Next would have refused it.
   */
  private isDobEligible(): boolean {
    const dob = this.payLoadData.certificationPartOneBasicDetails.dob;
    if (!dob) {
      return true;
    }
    const dobDate = new Date(dob);
    const minAgeDate = new Date();
    minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
    if (dobDate > minAgeDate) {
      this.eligibilityPopupMsg =
        "You must be at least 18 years old to apply as a Certified Peer Recovery Specialist. If you have additional questions, please reach out to CPRS.TDMHSAS@tn.gov 800-560-5767.";
      this.eligibilityPopup = true;
      this.isErrDobAge = true;
      setTimeout(() => {
        const el = document.querySelector(".dob-age-error") as HTMLElement;
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
      return false;
    }
    this.isErrDobAge = false;
    return true;
  }

  public nextButton() {
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    // Finalizing from the signature step must not skip earlier steps: if any is
    // incomplete (free-nav jumped past it), send the user back to it.
    const signatureStep = this.dataStepSlugs.length - 1;
    if (this.formPagination === signatureStep) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== signatureStep) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    if (this.formPagination === 0 && !this.isDobEligible()) {
      return;
    }
    this.payLoadData.certificationPartOneBasicDetails.state =
      this.payLoadData.certificationPartOneBasicDetails.state.toLocaleUpperCase();
    //signature validation
    if (this.formPagination == 3) {
      this.payLoadData.certificationPartOneSignature.submissionDate =
        moment().format("MM-DD-YYYY");
    }
    if (this.formPagination == 4) {
      this.payLoadData.certificationPartOneSignature.submissionDate =
        moment().format("MM-DD-YYYY");
      if (this.payLoadData.certificationPartOneSignature.isSignature) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
        return;
      }
    }
    if (this.formPagination == 2) {
      const content: any = this.formData.find(
        (form) =>
          form.parent_slug ===
          "certificationPartOneProgrammaticEligibilityQuestions"
      );
      if (
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
          .recoveryFromMentalDisorder === "No" &&
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
          .recoveryFromSubstanceDisorder === "No"
      ) {
        this.eligibilityPopupMsg = content.fields.disorderPopupMsg;
        this.eligibilityPopup = true;
        return;
      }
      if (
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
          .recoveryFromSubstanceDisorderLastYear === "No" ||
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
          .isRecoveryFromMentalDisorder === "No"
      ) {
        this.eligibilityPopup = true;
        this.eligibilityPopupMsg = content.fields.substanceDisorderPopupMsg;
        return;
      }
      if (
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
          .conservator === "do have a conservator"
      ) {
        this.eligibilityPopup = true;
        this.eligibilityPopupMsg = content.fields.conservertorPopupMsg;
        return;
      }
    }

    this.$validator.validateAll().then(async (validate: any) => {
      if (validate && !this.notFilesUploadedKeyNames.length) {
        // The step being completed NOW, before nextPaginationUpdate() advances
        // formPagination to the next step — mark this one, not the next.
        const completedStep = this.formPagination;
        if (
          this.payLoadData.certificationPartOneBasicDetails.workEmail === ""
        ) {
          this.payLoadData.certificationPartOneBasicDetails.workEmail = null;
        }
        this.checkValidForm = false;
        this.isLoading = true;
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.draftSave;
        if (!this.payLoadData.id) {
          await trainingFormApi
            .TrainingApplicationForm(
              this.payLoadData.fillStatus,
              this.payLoadData,
              this.currentRoute.split("/")[2]
            )
            .then((result: any) => {
              this.isLoading = false;
              this.formApplicationId = result.headers.location;
              localStorage.setItem(
                "partOneCertificateApplicationId",
                this.formApplicationId
              );
              this.payLoadData.id = localStorage.getItem(
                "partOneCertificateApplicationId"
              );
              localStorage.setItem(
                "partOneCertificatePayload",
                JSON.stringify(this.payLoadData)
              );
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          const id = this.payLoadData.id;
          await trainingFormApi
            .updateTrainingForm(
              this.payLoadData,
              id,
              this.currentRoute.split("/")[2]
            )
            .then((data) => {
              this.isLoading = false;
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
          localStorage.setItem(
            "partOneCertificatePayload",
            JSON.stringify(this.payLoadData)
          );
          if (this.isEdit) {
            this.formPagination = 5;
          }
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        localStorage.setItem(
          "partOneFormFilledIndex",
          this.formCompletedIndex.toString()
        );
        this.currentForm = this.payLoadData[this.formName];
        localStorage.setItem(
          "partOneCertificatePayload",
          JSON.stringify(this.payLoadData)
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public resetFileKey(event: boolean) {
    if (event) {
      this.notFilesUploadedKeyNames = [];
    }
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "certificationPartOneBasicDetails";
      } else if (page == 1) {
        this.formName = "certificationPartOneEducationExperience";
      } else if (page == 2) {
        this.formName = "certificationPartOneProgrammaticEligibilityQuestions";
      } else if (page == 3) {
        this.formName = "certificationPartOneRecoveryNarrative";
      } else if (page == 4) {
        this.formName = "certificationPartOneSignature";
      }
      this.formPagination = page;
    }
  }

  public async saveDraft() {
    this.$bvToast.show("example-toast");
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    localStorage.setItem(
      "partOneCertificatePayload",
      JSON.stringify(this.payLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public previousButton() {
    this.isEdit = false;
    this.checkValidForm = false;
    this.notFilesUploadedKeyNames = [];
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "certificationPartOneBasicDetails";
      } else if (this.formPagination == 1) {
        this.formName = "certificationPartOneEducationExperience";
      } else if (this.formPagination == 2) {
        this.formName = "certificationPartOneProgrammaticEligibilityQuestions";
      } else if (this.formPagination == 3) {
        this.formName = "certificationPartOneRecoveryNarrative";
      } else if (this.formPagination == 4) {
        this.formName = "certificationPartOneSignature";
      }
    }
  }

  public onSubmit() {
    this.$validator.validate().then((validate: any) => {
      if (validate) {
        this.payLoadData.certificationPartOneBasicDetails.state =
          this.payLoadData.certificationPartOneBasicDetails.state.toLocaleUpperCase();
        this.payLoadData.certificationPartOneSignature.submissionDate =
          moment().format("MM-DD-YYYY");
        let payloadStorage: any = localStorage.getItem(
          "partOneCertificatePayload"
        );
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.payLoadData = { ...this.payLoadData, ...payloadStorage };
        }
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.payLoadData.fillStatus = "COMPLETED";
        if (
          this.payLoadData.certificationPartOneBasicDetails.workEmail === ""
        ) {
          this.payLoadData.certificationPartOneBasicDetails.workEmail = null;
        }
        if (localStorage.getItem("partOneCertificateApplicationId")) {
          this.payLoadData.id = localStorage.getItem(
            "partOneCertificateApplicationId"
          );
        }
        const id = this.payLoadData.id;
        trainingFormApi
          .updateTrainingForm(
            this.payLoadData,
            id,
            this.currentRoute.split("/")[2]
          )
          .then(() => {
            trainingFormApi
              .getTrainingApplicationForm(id, this.currentRoute.split("/")[2])
              .then((result: any) => {
                localStorage.removeItem("anonymousToken");
                const applicationCode = result.data.code;
                const applicationNameData = {
                  title: "Certified Peer Recovery Specialist Application",
                  SubTitle: "Certification: Part One",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: applicationNameData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("partOneCertificatePayload");
            localStorage.removeItem("partOneCertificateApplicationId");
            localStorage.removeItem("partOneFormFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public emptyEvent() {
    return;
  }

  public fieldUpdate(groupName = "", initial = false) {
    switch (groupName) {
      case "ethnicHeritage":
        if (
          !this.payLoadData.certificationPartOneBasicDetails.ethnicHeritage.includes(
            "Not Listed (Please Specify):"
          )
        ) {
          if (!this.hideDiv.includes("ethnicHeritageNotListed") && !initial) {
            this.hideDiv.push("ethnicHeritageNotListed");
            this.payLoadData.certificationPartOneBasicDetails.ethnicHeritageNotListed =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("ethnicHeritageNotListed") >= 0) {
            this.hideDiv.splice(
              this.hideDiv.indexOf("ethnicHeritageNotListed"),
              1
            );
          }
        }
        break;
      case "highSchool":
        if (
          !this.payLoadData.certificationPartOneEducationExperience.highSchool.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("highSchoolNotListed") && !initial) {
            this.hideDiv.push("highSchoolNotListed");
            this.payLoadData.certificationPartOneEducationExperience.highSchoolNotListed =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("highSchoolNotListed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("highSchoolNotListed"), 1);
          }
        }
        break;
      case "licences":
        if (
          !this.payLoadData.certificationPartOneEducationExperience.licences?.includes(
            "Other"
          )
        ) {
          if (!initial) {
            this.payLoadData.certificationPartOneEducationExperience.licencesNotListed =
              "";
            if (!this.hideDiv.includes("licencesNotListed")) {
              this.hideDiv.push("licencesNotListed");
            }
          } else if (this.hideDiv.includes("licencesNotListed")) {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("licencesNotListed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("licencesNotListed"), 1);
          }
        }
        break;
      case "recoveryFromMentalDisorder":
        if (
          this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
            .recoveryFromMentalDisorder === "Yes"
        ) {
          if (this.hideDiv.indexOf("isRecoveryFromMentalDisorder") >= 0) {
            this.hideDiv.splice(
              this.hideDiv.indexOf("isRecoveryFromMentalDisorder"),
              1
            );
          }
        } else {
          // if (
          //   this.payLoadData
          //     .certificationPartOneProgrammaticEligibilityQuestions
          //     .recoveryFromMentalDisorder === "No"
          // ) {
          //   this.eligibilityPopup = true;
          // }

          if (
            !this.hideDiv.includes("isRecoveryFromMentalDisorder") &&
            !initial
          ) {
            this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions.isRecoveryFromMentalDisorder =
              [];
            this.hideDiv.push("isRecoveryFromMentalDisorder");
          } else {
            return;
          }
        }
        break;
      case "recoveryFromSubstanceDisorder":
        if (
          this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
            .recoveryFromSubstanceDisorder === "Yes"
        ) {
          if (
            this.hideDiv.indexOf("recoveryFromSubstanceDisorderLastYear") >= 0
          ) {
            this.hideDiv.splice(
              this.hideDiv.indexOf("recoveryFromSubstanceDisorderLastYear"),
              1
            );
          }
        } else {
          // if (
          //   this.payLoadData
          //     .certificationPartOneProgrammaticEligibilityQuestions
          //     .recoveryFromSubstanceDisorder === "No"
          // ) {
          //   this.eligibilityPopup = true;
          // }
          if (
            !this.hideDiv.includes("recoveryFromSubstanceDisorderLastYear") &&
            !initial
          ) {
            this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions.recoveryFromSubstanceDisorderLastYear =
              [];
            this.hideDiv.push("recoveryFromSubstanceDisorderLastYear");
          } else {
            return;
          }
        }
        break;
      // case "recoveryFromSubstanceDisorderLastYear":
      //   if (
      //     this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
      //       .recoveryFromSubstanceDisorderLastYear === "No"
      //   ) {
      //     this.eligibilityPopup = true;
      //   }
      //   break;
      // case "conservator":
      //   if (
      //     this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions
      //       .conservator === "do have a conservator"
      //   ) {
      //     this.eligibilityPopup = true;
      //   }
      //   break;
      case "ledAGroup":
        if (
          this.payLoadData.certificationPartOneRecoveryNarrative.ledAGroup ===
          "Yes"
        ) {
          this.payLoadData.certificationPartOneRecoveryNarrative.likeAboutLed =
            initial
              ? this.payLoadData.certificationPartOneRecoveryNarrative
                  .likeAboutLed
              : "";
          this.payLoadData.certificationPartOneRecoveryNarrative.groupLeadFeel =
            "";
          if (this.hideDiv.indexOf("likeAboutLed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("likeAboutLed"), 1);
          }
          if (!this.hideDiv.includes("groupLeadFeel") && !initial) {
            this.hideDiv.push("groupLeadFeel");
          }
        } else if (
          this.payLoadData.certificationPartOneRecoveryNarrative.ledAGroup ===
          "No"
        ) {
          this.payLoadData.certificationPartOneRecoveryNarrative.groupLeadFeel =
            initial
              ? this.payLoadData.certificationPartOneRecoveryNarrative
                  .groupLeadFeel
              : "";
          this.payLoadData.certificationPartOneRecoveryNarrative.likeAboutLed =
            "";
          if (this.hideDiv.indexOf("groupLeadFeel") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("groupLeadFeel"), 1);
          }
          if (!this.hideDiv.includes("likeAboutLed") && !initial) {
            this.hideDiv.push("likeAboutLed");
          }
        }
        break;
      case "taughtAClass":
        if (
          this.payLoadData.certificationPartOneRecoveryNarrative
            .taughtAClass === "Yes"
        ) {
          this.payLoadData.certificationPartOneRecoveryNarrative.likeAboutTaught =
            initial
              ? this.payLoadData.certificationPartOneRecoveryNarrative
                  .likeAboutTaught
              : "";
          this.payLoadData.certificationPartOneRecoveryNarrative.feelAboutTeaching =
            "";
          if (this.hideDiv.indexOf("likeAboutTaught") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("likeAboutTaught"), 1);
          }
          if (!this.hideDiv.includes("feelAboutTeaching") && !initial) {
            this.hideDiv.push("feelAboutTeaching");
          }
        } else if (
          this.payLoadData.certificationPartOneRecoveryNarrative
            .taughtAClass === "No"
        ) {
          this.payLoadData.certificationPartOneRecoveryNarrative.feelAboutTeaching =
            initial
              ? this.payLoadData.certificationPartOneRecoveryNarrative
                  .feelAboutTeaching
              : "";
          this.payLoadData.certificationPartOneRecoveryNarrative.likeAboutTaught =
            "";
          if (this.hideDiv.indexOf("feelAboutTeaching") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("feelAboutTeaching"), 1);
          }
          if (!this.hideDiv.includes("likeAboutTaught") && !initial) {
            this.hideDiv.push("likeAboutTaught");
          }
        }
        break;
      default:
        break;
    }
  }

  // The five data steps, in order. Their index is also their tab index; Preview
  // is the tab right after the last one (index === dataStepSlugs.length).
  private dataStepSlugs: string[] = [
    "certificationPartOneBasicDetails",
    "certificationPartOneEducationExperience",
    "certificationPartOneProgrammaticEligibilityQuestions",
    "certificationPartOneRecoveryNarrative",
    "certificationPartOneSignature",
  ];

  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  /**
   * The checks Next runs on a step that vee-validate cannot see, so a silent
   * re-derivation judges a step exactly as Next would. Side-effect free: this
   * only decides whether a step counts as complete, it never opens a popup or
   * scrolls, because it runs while the user is on their way somewhere else.
   */
  /**
   * Payload rows come back from drafts that were saved by older shapes, so a
   * key can simply be absent. A bare .toLowerCase() on one of those throws, and
   * because these checks run inside navigateTab the throw took the tab click
   * with it — the click did nothing at all, with nothing in the console to say
   * why. Everything below reads through these two instead.
   */
  private lower(value: any): string {
    return typeof value === "string" ? value.toLowerCase() : "";
  }

  private duplicateRowIdx(section: string, field: string): number[] {
    const rows = this.payLoadData[section];
    if (!Array.isArray(rows)) {
      return [];
    }
    const seen = new Set<string>();
    const duplicates: number[] = [];
    rows.forEach((row: any, idx: number) => {
      const value = this.lower(row && row[field]);
      if (!value) {
        return;
      }
      if (seen.has(value)) {
        duplicates.push(idx);
      } else {
        seen.add(value);
      }
    });
    return duplicates;
  }

  /**
   * A refusal always has to say something. Validation errors and the messages
   * Next uses cover most of it, but a step can be held up by something with no
   * field to flag, and then the applicant is bounced to a tab that looks
   * perfectly fine and told nothing at all.
   */
  private announceBlockedStep(step: number) {
    setTimeout(() => {
      if (
        this.errorMessage ||
        document.getElementsByClassName("is-invalid").length
      ) {
        return;
      }
      const navName = (this.applicationNavData[step] || ({} as any)).name;
      const stepName = (navName || "").trim() || "this step";
      this.errorMessage = `Please complete ${stepName} before previewing the application.`;
    }, 300);
  }

  private stepExtraChecksPass(step: number): boolean {
    const payload = this.payLoadData;
    if (step === 0) {
      const dob = (payload.certificationPartOneBasicDetails || {}).dob;
      if (!dob) {
        return true;
      }
      const minAgeDate = new Date();
      minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
      return new Date(dob) <= minAgeDate;
    }
    if (step === 2) {
      const answers =
        payload.certificationPartOneProgrammaticEligibilityQuestions || {};
      return !(
        (answers.recoveryFromMentalDisorder === "No" &&
          answers.recoveryFromSubstanceDisorder === "No") ||
        answers.recoveryFromSubstanceDisorderLastYear === "No" ||
        answers.isRecoveryFromMentalDisorder === "No" ||
        answers.conservator === "do have a conservator"
      );
    }
    if (step === this.dataStepSlugs.length - 1) {
      return !!(payload.certificationPartOneSignature || {}).isSignature;
    }
    return true;
  }

  /**
   * Sync the rendered step's completion from a live validation: mark it
   * complete only when every required field validates, and UNMARK it when a
   * stale completion is left over. Validated silently — errors are cleared so
   * nothing flashes, since the user is leaving the tab, not being told off.
   *
   * Every data step is re-derived, not just Basic Details: a tab the applicant
   * filled in and then left by clicking another tab is finished whether or not
   * they pressed Next, and the Preview gate has to see that. Without this,
   * filling the last step and clicking Preview went nowhere — the step was not
   * marked, so the gate bounced the user straight back onto it.
   *
   * This also replaces the old "a saved id proves step 0 validated" shortcut.
   * Drafts are now created from a valid email alone, so an id no longer says
   * anything about the rest of the tab and would wrongly let a half-filled
   * application through the Preview and finalize gates.
   */
  /**
   * Bring every step Preview is waiting on onto the screen and judge it exactly
   * as Next judges it. One that passes is marked and the walk moves on; the
   * first that genuinely fails is handed back so the applicant lands there with
   * its own errors showing.
   *
   * Preview is still only for an application that is actually finished — but
   * "finished" has to mean the data is there, not that the applicant happened to
   * press Next on every tab. Filling a tab and clicking Preview is a perfectly
   * ordinary thing to do, and it used to lead nowhere.
   *
   * Returns the step that blocks Preview, or -1 when nothing does.
   */
  private async settleIncompleteSteps(): Promise<number> {
    let step = this.firstIncompleteDataStep();
    if (step === -1) {
      return -1;
    }
    const landedOn = this.formPagination;
    this.isLoading = true;
    try {
      while (step !== -1) {
        if (!(await this.settleStep(step))) {
          return step;
        }
        const next = this.firstIncompleteDataStep();
        // A step that reports itself complete and still comes back as the first
        // incomplete one would spin here forever; stop and let the applicant see
        // it instead.
        if (next === step) {
          return step;
        }
        step = next;
      }
      return -1;
    } catch (error) {
      // The walk is a convenience, never a trap: if judging a step throws, put
      // the applicant back where they were rather than leaving the click dead.
      this.formPagination = landedOn;
      this.formName = this.dataStepSlugs[landedOn] || this.formName;
      return landedOn;
    } finally {
      this.isLoading = false;
    }
  }

  private async settleStep(step: number): Promise<boolean> {
    if (step !== this.formPagination) {
      // vee-validate only knows the fields currently rendered, so a step has to
      // be on screen before it can be judged.
      this.formName = this.dataStepSlugs[step];
      this.formPagination = step;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    this.prepareStepForCompletion(step);
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    if (valid && this.stepExtraChecksPass(step)) {
      this.markStepComplete(step);
      return true;
    }
    if (valid) {
      this.explainStepBlock(step);
    }
    return false;
  }

  // What Next fills in on the applicant's behalf before it will judge a step.
  // The submission date is the whole reason Signature could never be completed
  // by filling the form: it is required, and only Next ever wrote it.
  private prepareStepForCompletion(step: number) {
    if (
      step === this.dataStepSlugs.length - 1 &&
      this.payLoadData.certificationPartOneSignature.isSignature
    ) {
      this.payLoadData.certificationPartOneSignature.submissionDate =
        moment().format("MM-DD-YYYY");
    }
  }

  // Say out loud why a tab is holding Preview up, in the words Next uses. The
  // rules below are invisible to vee-validate, so without this the applicant is
  // bounced back to a tab with every field filled and nothing flagged.
  private explainStepBlock(step: number) {
    if (step === 0) {
      this.isDobEligible();
      return;
    }
    if (step === 2) {
      const content: any = this.formData.find(
        (form: any) =>
          form.parent_slug ===
          "certificationPartOneProgrammaticEligibilityQuestions"
      );
      const answers =
        this.payLoadData.certificationPartOneProgrammaticEligibilityQuestions;
      if (
        answers.recoveryFromMentalDisorder === "No" &&
        answers.recoveryFromSubstanceDisorder === "No"
      ) {
        this.eligibilityPopupMsg = content?.fields?.disorderPopupMsg;
      } else if (answers.conservator === "do have a conservator") {
        this.eligibilityPopupMsg = content?.fields?.conservertorPopupMsg;
      } else {
        this.eligibilityPopupMsg = content?.fields?.substanceDisorderPopupMsg;
      }
      this.eligibilityPopup = true;
      return;
    }
    if (step === this.dataStepSlugs.length - 1) {
      this.signatureInvalid = true;
    }
  }

  // Record a step as completed. The silent pass and the Preview gate both land
  // here so there is one definition of "done" and one write to storage.
  private markStepComplete(step: number) {
    if (!this.formCompletedIndex.includes(step)) {
      this.formCompletedIndex.push(step);
    }
    localStorage.setItem(
      "partOneFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  private async markCurrentStepIfComplete() {
    try {
      await this.deriveCurrentStepCompletion();
    } catch (error) {
      // Judging a step is a convenience. If it throws, the applicant still gets
      // to change tabs — the gate below decides what happens next.
    }
  }

  private async deriveCurrentStepCompletion() {
    const step = this.formPagination;
    if (step >= this.dataStepSlugs.length || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    const complete =
      valid &&
      !this.notFilesUploadedKeyNames.length &&
      this.stepExtraChecksPass(step);
    const idx = this.formCompletedIndex.indexOf(step);
    if (complete) {
      this.markStepComplete(step);
    } else if (step === 0 && idx !== -1) {
      // Only Basic Details is ever unmarked here, which is what this check was
      // written for: a draft row exists from an email alone, so a stale mark has
      // to be corrected. A later step was marked by Next, which validated the
      // whole tab with everything rendered — a silent re-check that cannot see
      // as much must not be allowed to take that away and strand the applicant
      // on a tab that looks finished.
      this.formCompletedIndex.splice(idx, 1);
      localStorage.setItem(
        "partOneFormFilledIndex",
        this.formCompletedIndex.toString()
      );
    }
  }

  // On load, once Basic Details has rendered, re-derive its completion so a
  // stale "complete" mark (e.g. from an earlier draft) is corrected.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markCurrentStepIfComplete();
  }

  // First data step not yet completed via Next (which runs the step's full
  // vee-validate + custom checks), or -1 if all are done. Preview is only
  // reachable when this returns -1.
  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and surface its errors, so the user knows what to
  // finish before Preview.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.notFilesUploadedKeyNames = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    this.$nextTick(() => {
      this.$validator.validateAll().then(() => {
        // Let the error classes render, then scroll to the first missing field
        // (falling back to the top of the form if none is found).
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  /**
   * The payload section the rendered step edits. The template must never index
   * the payload directly: Preview is a step with no section of its own, and a
   * draft restored from an older shape can be missing one — either way an
   * undefined section throws on every render, which blanks the form and fills
   * the console rather than showing the step.
   */
  get currentSection() {
    return this.payLoadData[this.formName] || {};
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Leaving a data step: re-derive its completion so the Preview and finalize
    // gates know whether it is actually done — a tab the applicant finished and
    // left by clicking another tab counts, Next or no Next. Jumping away from an
    // unfinished tab is allowed — it just does not get marked complete.
    await this.markCurrentStepIfComplete();
    // Reaching Preview still requires every data step to be completed. If any is
    // incomplete, jump to the first one.
    if (index === this.dataStepSlugs.length) {
      const blocked = await this.settleIncompleteSteps();
      if (blocked !== -1) {
        this.jumpToIncompleteStep(blocked);
        this.announceBlockedStep(blocked);
        return;
      }
    }
    this.isEdit = false;
    this.checkValidForm = false;
    this.notFilesUploadedKeyNames = [];
    // Save whatever has been filled before leaving the tab, so nothing is lost.
    this.persistDraft();
    // Preview has no payload section of its own, but the step still owns the
    // slug: the template decides which block to render from formName, so
    // pinning it to the previous step rendered that step's fields on the
    // Preview tab. Nothing may index the payload by formName without a
    // fallback — the currentSection getter is what keeps an absent section
    // from throwing.
    this.formName = slug;
    this.formPagination = index;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Persist the current payload as a draft (fillStatus stays DRAFT), without
  // validation — used when the user jumps between parts. The row already exists
  // (created when Basic Details was completed), so this is always an update.
  // Draft saves are chained rather than fired in parallel: navigateTab does not
  // await this (the tab switches immediately), so jumping several tabs quickly
  // would otherwise leave overlapping PUTs racing, and the last response to
  // land wins regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "partOneCertificatePayload",
      JSON.stringify(this.payLoadData)
    );
  }

  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave.then(() => this.saveDraftNow());
    return this.draftSave;
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "partOneCertificatePayload",
      JSON.stringify(this.payLoadData)
    );
    const basicDetails = this.payLoadData.certificationPartOneBasicDetails;
    // A half-typed work email is rejected outright by the API
    // ("Invalid work email" from fetchDetailsfromData), so do not ask. The
    // applicant is mid-keystroke, not mistaken - the local copy above still has
    // it, and the field's own validation tells them if it is still wrong when
    // they try to move on.
    if (
      basicDetails.workEmail &&
      !utils.canSaveDraftRemotely(basicDetails.workEmail)
    ) {
      return;
    }
    if (!this.payLoadData.id) {
      if (!utils.canSaveDraftRemotely(basicDetails.email)) {
        return;
      }
      if (basicDetails.workEmail === "") {
        basicDetails.workEmail = null;
      }
      try {
        const result: any = await trainingFormApi.TrainingApplicationForm(
          this.payLoadData.fillStatus,
          this.payLoadData,
          this.currentRoute.split("/")[2]
        );
        this.formApplicationId = result.headers.location;
        localStorage.setItem(
          "partOneCertificateApplicationId",
          this.formApplicationId
        );
        this.payLoadData.id = this.formApplicationId;
        localStorage.setItem(
          "partOneCertificatePayload",
          JSON.stringify(this.payLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await trainingFormApi.updateTrainingForm(
        this.payLoadData,
        this.payLoadData.id,
        this.currentRoute.split("/")[2]
      );
    } catch (error) {
      // Silent, for the same reason the create above is: this save runs on a
      // timer the applicant did not start, so a popup over the field they are
      // typing in interrupts them about something they have not finished doing.
      // The local copy holds the work, and Next surfaces the real error.
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the logged-in prefill do not count as the applicant filling
  // anything in. From the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "payLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
  public goBack() {
    if (this.$route.query.isDraft) {
      localStorage.removeItem("partOneCertificatePayload");
    }
    this.$router.push({
      path: `/application`,
      query: {
        form: "part-one",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
  public closedEligibilityPopup(event: any) {
    this.eligibilityPopup = false;
    if (event) {
      this.goBack();
    } else if (this.isErrDobAge) {
      setTimeout(() => {
        const el = document.querySelector(".dob-age-error") as HTMLElement;
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  }
}
